import {
  FaBuilding,
  FaCheckCircle,
  FaClipboardList,
} from "react-icons/fa";

export const PROVIDER_STAT_CARDS = [
  {
    key: "totalProviders",
    label: "Total Providers",
    subtitle: "All registered providers",
    color: "#007bff",
    iconBg: "rgba(0, 123, 255, 0.1)",
    Icon: FaBuilding,
  },
  {
    key: "activeProviders",
    label: "Active Providers",
    subtitle: "Currently active",
    color: "#059669",
    iconBg: "rgba(5, 150, 105, 0.1)",
    Icon: FaCheckCircle,
  },
  {
    key: "totalApplications",
    label: "Total Applications",
    subtitle: "Across all providers",
    color: "#7c3aed",
    iconBg: "rgba(124, 58, 237, 0.1)",
    Icon: FaClipboardList,
  },
];
